export default __webpack_public_path__ + "static/media/detail_big_5_3.a8003b6f.png";